export const QUERY_PARAMETERS = {
    sampleSet: 'SampleSet'
};

export const API_SLICE_TAGS = {
    configurations: 'configurations',
    configurationDisplays: 'configurationDisplays',
    securityDefinitions: 'securityDefinitions',
    users: 'users',
    entraSecurity: 'entraSecurity',
}

export const MICROSOFT_LOGIN_URL = "https://login.microsoftonline.com"